import { Button } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { otenerReporteEgresosMxnAction } from "../../../ducks/reportesDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { ToastMessage } from "../../../global/ToastMessage";
import { catRoles } from "../../../constant/catRoles"
import { usePermiso } from "../../../hooks/usePermiso"
import { FormatoFecha } from "../../../utils/FormatFecha";
const ButtonReporteEgresosMxn = () => {
    const { profile } = useSelector(store => store.logeo)
    const { egresosFechaFin, egresosFechaInicio } = useSelector(store => store.reportes)
    const [permitido] = usePermiso({ location: "FK_AdministrarClientes_Reportes", initialValue: false })
    const dispatch = useDispatch()
    const handleDowload = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(otenerReporteEgresosMxnAction({
            FechaIni: FormatoFecha({ date: egresosFechaInicio, formato: "MMddyyyy" }),
            FechaFin: FormatoFecha({ date: egresosFechaFin, formato: "MMddyyyy" }),
        })).then((Response) => {
            const downloadUrl = window.URL.createObjectURL(
                new Blob([Response.data], { type: "application/vnd.ms-excel" })
            )
            const link = document.createElement('a');
            link.href = downloadUrl;
            let fchAct = new Date().toISOString();
            let fileName = 'Egresos MXN -' + fchAct + '.xlsx'
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            ToastMessage.fire({
                icon: "success",
                title: "¡OPERACIÓN EXITOSA!"
            });
            dispatch(offLoadAction())
        });

    }
    if (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitido) return (
        <div>
            <Button onClick={handleDowload} variant="contained" color="primary">Descargar reporte MXN</Button>
        </div>
    )
    return null
}
export default ButtonReporteEgresosMxn